import { Link } from "react-router-dom";
import { Wordmark } from "@/components/Brand";
import { CONTACT_EMAIL, APK_URL, APP_STORE_URL } from "@/lib/brand";
import { Mail, Download, Apple } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative grain bg-[#1E1E1E] text-white pt-20 pb-10 overflow-hidden">
      <div className="absolute inset-0 techgrid-dark opacity-40" />
      <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Wordmark light />
            <p className="mt-5 max-w-sm text-white/55 leading-relaxed">
              The professional toolkit for driving instructors. Structured, spatial, cognitively
              compressed feedback — built in Australia.
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <a
                href={APK_URL}
                data-testid="footer-download-btn"
                className="inline-flex items-center gap-2 rounded-full bg-[#2BBFB3] px-6 py-3 text-sm font-semibold text-[#0f1211] hover:bg-[#1FA097] transition-colors"
              >
                <Download size={16} /> Download for Android
              </a>
              <a
                href={APP_STORE_URL}
                data-testid="footer-download-ios-btn"
                className="inline-flex items-center gap-2 rounded-full bg-[#2BBFB3] px-6 py-3 text-sm font-semibold text-[#0f1211] hover:bg-[#1FA097] transition-colors"
              >
                <Apple size={16} /> Download for iOS
              </a>
            </div>
          </div>

          <div className="lg:col-span-3 lg:col-start-8">
            <p className="overline text-white/40">Product</p>
            <ul className="mt-4 space-y-3 text-sm">
              {[
                ["The problem", "#problem"],
                ["Try it yourself", "#demo"],
                ["Features", "#features"],
                ["Pricing", "#pricing"],
                ["Founder Program", "#founder"],
              ].map(([l, h]) => (
                <li key={h}>
                  <a href={h} className="text-white/60 hover:text-[#2BBFB3] transition-colors">{l}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="overline text-white/40">Contact</p>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              data-testid="footer-contact-email"
              className="mt-4 inline-flex items-center gap-2 text-sm text-white/70 hover:text-[#2BBFB3] transition-colors break-all"
            >
              <Mail size={15} /> {CONTACT_EMAIL}
            </a>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-white/45">
          <p>© {new Date().getFullYear()} DriveAssure. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy-policy" data-testid="footer-privacy-link" className="hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" data-testid="footer-terms-link" className="hover:text-white transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
